import {EventEmitter, Injectable} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApprovalModel} from '../dto/approval.model';
import {Observable} from 'rxjs/index';
import {HttpClient} from '@angular/common/http';
import {ApprovalPending} from '../dto/approval-pending';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class ReversedSuspendBlacklistService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers;
  public model = new EventEmitter<NgbModal>();

  /* Search Reversed Suspend To Blacklist Request Details */
  searchRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/searchRequestData', data);
  }

  /* Get All Request Details */
  getAllRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/getRequestData', data);
  }

  /* Get All Return Request Details */
  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/getReturnRequest', data);
  }

  /* Get All DG Return Request Details */
  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/getDGReturnRequest', data);
  }

  /* Search Pending Request For Verification */
  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/searchPendingRequests', data);
  }

  /* Get Applicant Details  By Req Id */
  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'revered-suspend-blacklist/getApplicantDetails/'+ applicationId);
  }

  /* Approve Reverse Suspend To Blacklist Requests */
  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/approveRequest', approvalModel, {headers: this.headers});
  }

  /* Get All Pending Requests For Verification */
  getPendingVerificationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/getPendingRequests',approvalModel,{headers: this.headers});
  }


  /* Get All Pending Requests For Authorization */
  getPendingAuthorizationRequests(approvalModel: ApprovalModel): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/getPendingAuthList',approvalModel,{headers: this.headers});
  }

  /* Get All Return Request Details */
  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'revered-suspend-blacklist/returnRequest', approvalModel, {headers: this.headers});
  }

  /* Save Document Details in Reverse Suspend To Blacklist Process */
  saveDocumentTypeAndDetails(details) {
    return this.httpClient.post<any>(this.baseUrl + 'revered-suspend-blacklist/saveDocumentDetails', details);
  }
}
